import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { HowItWorks } from './components/HowItWorks';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="2wjqi594yq8np">
      <div className="min-h-screen w-full bg-white font-sans text-neutral-900" data-id="element-1" data-mp="2wj8e3qc26q58">
        <Navbar data-id="element-2" data-mp="28tmej1rry8wp" />
        <main data-id="element-3" data-mp="28t4ju9krg2qw">
          <Hero data-id="element-4" data-mp="28sl48zil1qg1" />
          <TrustBar data-id="element-5" data-mp="28s2x37udtrtc" />
          <Services data-id="element-6" data-mp="23vkuoemiy5k6" />
          <WhyChooseUs data-id="element-7" data-mp="23w4clvc6cty7" />
          <HowItWorks data-id="element-8" data-mp="23utas12ahw9q" />
          <Gallery data-id="element-9" data-mp="23t8eo70bu59r" />
          <Testimonials data-id="element-10" data-mp="3ik7gihlkcdr6" />
          <Faq data-id="element-11" data-mp="3ikqwvtvkeu33" />
          <ContactSection data-id="element-12" data-mp="3ij65ue8glt9z" />
        </main>
        <Footer data-id="element-13" data-mp="3ii4ppvcl6gle" />
        <WhatsAppButton data-id="element-14" data-mp="3mlat8v8bdto6" />
      </div>
    </LanguageProvider>;
}